export const AG_GRID_LOCALE_FR = {
    contains: 'Contient',
    notContains: 'Ne contient pas',
    startsWith: 'Commence avec',
    endsWith: 'Se termine par',
    equals: 'Équivaut à',
    notEqual: 'Inégal',
    filterOoo: 'Filtre...'
}